import { render } from "./sidebar-icon.vue?vue&type=template&id=3ac89e25&scoped=true"
import script from "./sidebar-icon.vue?vue&type=script&lang=js"
export * from "./sidebar-icon.vue?vue&type=script&lang=js"

import "./sidebar-icon.vue?vue&type=style&index=0&id=3ac89e25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac89e25"]])

export default __exports__